import { render, staticRenderFns } from "./NewButton.vue?vue&type=template&id=a7998ac2&scoped=true"
import script from "./NewButton.vue?vue&type=script&lang=js"
export * from "./NewButton.vue?vue&type=script&lang=js"
import style0 from "./NewButton.vue?vue&type=style&index=0&id=a7998ac2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7998ac2",
  null
  
)

export default component.exports